import React, { Component } from 'react';

import { track } from '../../../utils/analytics';

import style from './index.module.scss';

export default class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ctaColor: null,
      ctaBackground: null,
      ctaBorder: 'transparent'
    }

    this.handleClickOut = this.handleClickOut.bind(this);
    this.handleCTAMouseOver = this.handleCTAMouseOver.bind(this);
    this.handleCTAMouseOut = this.handleCTAMouseOut.bind(this);
  }

  handleCTAMouseOver() {
    const { primaryColor } = this.props;
    this.setState(() => ({ ctaColor: 'white', ctaBackground: primaryColor, ctaBorder: 'white' }));
  }

  handleCTAMouseOut() {
    const { primaryColor } = this.props;
    this.setState(() => ({ ctaColor: primaryColor, ctaBackground: 'white', ctaBorder: 'transparent' }));
  }

  handleClickOut() {
    const { productClickUrl, productName } = this.props;
    track('clicked', `buy product - ${productName.replace(/<\/?[^>]+(>|$)/g, ' ')}`);
    window.open(productClickUrl);
  }

  componentDidMount() {
    const { primaryColor } = this.props;
    this.setState(() => ({ ctaColor: primaryColor, ctaBackground: 'white', ctaBorder: 'transparent' }));
  }

  render() {
    const { productBrandName, productName, productImageUrl } = this.props;
    const { ctaColor, ctaBackground, ctaBorder } = this.state;

    return (
      <div className={style.product}>
        {/* <div className={style.image} style={{ background: `url(${productImageUrl}) no-repeat center center` }} >
          {renderMask(shape, primaryColor)}
        </div> */}
        <div className={style.image}><img src={productImageUrl} alt="product" /></div>
        <div className={style.brand}>{productBrandName}</div>
        <div className={style.name}>{productName}</div>
        <div className={style.cta} onMouseOver={this.handleCTAMouseOver} onMouseOut={this.handleCTAMouseOut} style={{ color: ctaColor, background: ctaBackground, border: `2px solid ${ctaBorder}` }} onClick={this.handleClickOut}>BUY NOW</div>
      </div>
    )
  }
}
